module.exports = __webpack_public_path__ + "static/media/aqua_07.88f268a5.JPG";